import { ArrowUpRight, FileText } from "lucide-react";
import { useEffect } from "react";

const PRIVACY_PDF_URL = "https://customer-assets-eiarnc6j.emergentagent.net/job_umzug-markgraefler/artifacts/vhqwfam0_Datenschutzerklaerung_Van_Akkeren_Raeumungsservice.pdf";

const pageCopy = {
  title: "Impressum",
  label: "Rechtliches / 01",
};

export default function LegalPage({ kind }) {
  const isPrivacy = kind === "datenschutz";
  const title = isPrivacy ? "Datenschutzerklärung" : pageCopy.title;

  useEffect(() => {
    document.title = `${title} | VanAkkeren Räumungsservice`;
    return () => { document.title = "VanAkkeren Räumungsservice | Müllheim & Markgräflerland"; };
  }, [title]);

  if (isPrivacy) {
    return (
      <div className="legal-page">
        <div className="container legal-container privacy-only-page">
          <span className="eyebrow">Rechtliches / 02</span>
          <h1>Datenschutzerklärung</h1>
          <div className="legal-placeholder privacy-pdf-card" data-testid="privacy-pdf-only-card">
            <span className="mono-label">DOKUMENT</span>
            <h2>Datenschutzerklärung als PDF</h2>
            <a className="button button-dark legal-pdf-link" href={PRIVACY_PDF_URL} target="_blank" rel="noreferrer" data-testid="privacy-pdf-link">
              <FileText size={17} strokeWidth={1.8} /> PDF öffnen <ArrowUpRight size={17} strokeWidth={1.8} />
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <div className="container legal-container">
        <span className="eyebrow">{pageCopy.label}</span>
        <h1>{pageCopy.title}</h1>
        <div className="legal-content">
          <div className="legal-placeholder legal-document" data-testid="impressum-content">
            <span className="mono-label">ANBIETER</span>
            <h2>Sebastian Fuchs<br />VanAkkeren Räumungsservice</h2>
            <p>Einzelunternehmen</p>
            <div className="legal-detail-block">
              <span className="mono-label">ANSCHRIFT</span>
              <address data-testid="impressum-address">Posthalterweg 10<br />79379 Müllheim</address>
            </div>
            <div className="legal-detail-block">
              <span className="mono-label">KONTAKT</span>
              <a href="tel:+4915568199384" data-testid="impressum-phone-link">0155 68199384</a>
              <a href="mailto:van.akkeren.raeumungsservice@gmail.com" data-testid="impressum-email-link">van.akkeren.raeumungsservice@gmail.com</a>
              <a href="https://www.instagram.com/van.akkeren.raeumungsservice/" target="_blank" rel="noreferrer" data-testid="impressum-instagram-link">@van.akkeren.raeumungsservice</a>
            </div>
            <div className="legal-detail-block" data-testid="impressum-responsible-info">
              <span className="mono-label">VERANTWORTLICH FÜR DEN INHALT</span>
              <p>Sebastian Fuchs<br />Posthalterweg 10<br />79379 Müllheim</p>
            </div>
            <div className="legal-detail-block">
              <span className="mono-label">STEUERLICHE ANGABE</span>
              <p>Keine Umsatzsteuer-Identifikationsnummer vorhanden.</p>
            </div>
          </div>
          <aside className="legal-aside">
            <span className="mono-label">VANAKKEREN RÄUMUNGSSERVICE</span>
            <p>Müllheim & Umgebung</p>
            <a href="tel:+4915568199384" data-testid="impressum-aside-phone-link">Anrufen</a>
            <a href="mailto:van.akkeren.raeumungsservice@gmail.com" data-testid="impressum-aside-email-link">E-Mail schreiben</a>
            <a href="https://www.instagram.com/van.akkeren.raeumungsservice/" target="_blank" rel="noreferrer" data-testid="impressum-aside-instagram-link">Instagram öffnen</a>
          </aside>
        </div>
      </div>
    </div>
  );
}
